import { Component, OnInit, OnDestroy } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { EditTimesheetService } from "./edit-timesheet.service";
import { IMyOptions, IMyDateModel } from "mydatepicker";
import { MatSnackBar } from "@angular/material";
import { EditTimesheet } from "./edit-timesheet";
import "rxjs/add/operator/takeWhile";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

@Component({
  selector: "app-edit-timesheet",
  templateUrl: "./edit-timesheet.component.html",
  styleUrls: ["./edit-timesheet.component.css"],
})
export class EditTimesheetComponent implements OnInit, OnDestroy {
  public employeelistarr: any = []; // Array of Object of Employee working under logged RM is stored
  public filteredEmpOptions: Observable<string[]>; // And Observable string array to store the filtered Employee List (Auto complete)
  public empName: string; // Variable to store the employee name selected from autocomplete
  public myDatePickerOptions: IMyOptions; // Date picker confi
  public startDate: any; // Date which needs to be made as editable
  public editTimesheet: any = new EditTimesheet({});
  private alive: boolean = true; // A variable to unsubscribe the observable service call from Memory leak

  constructor(
    public editTimesheetService: EditTimesheetService,
    public matSnackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    const date: Date = new Date();
    date.setDate(date.getDate() + 1);

    this.myDatePickerOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: false,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };
  }

  ngOnInit() {
    this.getEmployeeLists();
  }

  /**
   * @function filterEmployeeEntities
   * @description
   * Filter to search the Employee in the employee list upon keydown using auto complete module
   * @param event The associated $event upon keydown on the input box
   * @returns null
   * @var filteredEmpOtions The employee list which matches the search key is stored for UI view
   * @author gaurav.rao
   */
  filterEmployeeEntities(event: any) {
    const searchItem = event.target.value;
    if (event.target.value !== "undefined") {
      this.filteredEmpOptions = this.employeelistarr.filter(
        (s) =>
          s.employeeDetails.Empname.toLowerCase().indexOf(
            searchItem.toLowerCase()
          ) == 0
      );
    }
  }

  /**
   * @function employeeSelected
   * @description
   * A function to store value selected upon click on the Auto complete dropdown.
   * The employee Employee id and employee Name is stored for the further use
   * @param option The selected object from the dropdown
   * @var empName Variable to store the Employee Name
   * @author gaurav.rao
   */
  employeeSelected(option) {
    this.editTimesheet.empno = option.employeeDetails.Empno;
    this.empName = option.employeeDetails.Empname;
  }

  /**
   * @function getEmployeeLists()
   * @description
   * Function to get the employee list from the Backend which will be given as input for the Auto complete module for
   * further filter
   * @var employeelistarr An Array of object to store the employee list obtainde from the API call for the view purpose
   * @author gaurav.rao
   */
  getEmployeeLists() {
    this.employeelistarr = [];
    this.spinnerService.show();
    this.editTimesheetService
      .getEmployeesDetails(null, null)
      .takeWhile(() => this.alive)
      .subscribe(
        (data) => {
          this.spinnerService.hide();
          if (data.payload.employees) {
            data.payload.employees.map((value) =>
              this.employeelistarr.push(value)
            );
          }
        },
        (error) => {
          this.spinnerService.hide();
        }
      );
  }

  /**
   * @function enableTimesheet()
   * @description
   * Function to enable the timesheet for the particular user based upon the date
   * selected from the datepicker. An api call is made only if all the necessary condition is satisfied
   * Employee number and date is the Required field for API Call
   * @class EditTimesheet class with necessary field to be passed to the backend
   * @author gaurav.rao
   */
  enableTimesheet() {
    this.editTimesheet.selectedstartDate =
      this.startDate.date.year +
      "-" +
      this.startDate.date.month +
      "-" +
      this.startDate.date.day;
    this.editTimesheetService
      .enableTimesheet(this.editTimesheet)
      .takeWhile(() => this.alive)
      .subscribe(
        (data) => {
          this.matSnackBar.open(
            "Timesheet Succesfully enabled for the user",
            "",
            {
              duration: 3000,
            }
          );
          this.empName = "";
          this.startDate = null;
        },
        (error) => {
          this.matSnackBar.open(
            "Error occurred while enabling the timesheet for the user",
            "",
            {
              duration: 3000,
            }
          );
        }
      );
  }

  /**
   * @function ngOnDestroy()
   * @description
   * Function to destroy the Subscription used while calling API
   * Unsubscribe the observable is done using takeUntil method of rxjs
   * @author gaurav.rao
   */
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/edit-timesheet/edit-timesheet.component.ts